import React from 'react';
import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import { styled } from '@mui/system';

interface CustomFormControlForSelectProps {
  label: string;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  children: React.ReactNode;
}

const StyledFormControl = styled(FormControl)(({ theme }) => {
  // const palette = theme.palette || { primary: { main: '#1976d2' } }; // Fallback value for theme
  return {
    marginTop: '16px',
    position: 'relative',
    '& .MuiInputLabel-root': {
      backgroundColor: '#fff',
      padding: '0 4px',
      left: '-4px',
      transform: 'translate(14px, 12px) scale(1)',
    },
    '& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiFormLabel-filled': {
      transform: 'translate(14px, -6px) scale(0.75)',
      backgroundColor: '#fff',
      // color: palette.primary.main,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      // borderColor: palette.primary.main,
    },
    '& .MuiSelect-root': {
      padding: '16.5px 14px',
    },
  };
});

const CustomFormControlForSelect: React.FC<CustomFormControlForSelectProps> = ({
  label,
  fullWidth = true,
  error,
  helperText,
  children,
}) => {
  return (
    <StyledFormControl fullWidth={fullWidth} variant="outlined" error={error}>
      <InputLabel shrink>{label}</InputLabel>
      {children}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </StyledFormControl>
  );
};

export default CustomFormControlForSelect;
